module.exports = __webpack_public_path__ + "static/media/1-3-v-betleme-porodila.22f77f2c.jpg";